import React, { useEffect, useState } from 'react';
import { getdata, updatedata, deletedata } from "../../util/global";
import { product, productdef } from './Datatype';
import ProductTable from './ProductTable';
import ProductForm from './ProductForm';
import ProductView from './ProductView';

const Product = () => {
  const [products, setproducts] = useState<product[]>([]);
  const [showmodal, setshowmodal] = useState("");
  const [formdata, setformdata] = useState<product>(productdef);
  const [files, setfiles] = useState<any[]>([]);

  const fetchdata = async () => {
    try {
      const res = await getdata({ filter: { datatype: "productdata" } });
      setproducts(res ? [...res].reverse() : []);
      const filedata = await getdata({ filter: { datatype: "filedata", filetype: "productfile", dbcollection: "appfiledata" } });
      setfiles(filedata);
    } catch (err) {
      console.error(err);
    }
  };

  const openadd = () => {
    setformdata({ ...productdef });
    setshowmodal("showproductform");
  };

  const openedit = (item: product) => {
    setformdata({ ...item });
    setshowmodal("showproductform");
  };
  const openview = (item: product) => {
    setformdata({ ...item });
    setshowmodal("showproductview");
  };

  const deleteproduct = (item: product) => {
    if (!confirm(`delete product ${item.name}?`)) return;
    deletedata({ filter: { datatype: "productdata", _id: item._id } }, () => {
      fetchdata();
    });
  };

  const changestatus = async (item: product, status: string) => {
    await updatedata({ data: { ...item, status } });
    fetchdata();
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3>Products</h3>
        <button className="btn-blue" onClick={openadd}>+ Add Product</button>
      </div>

      <ProductTable 
        products={products}
        openedit={openedit}
        openview={openview}

        deleteproduct={deleteproduct}
        changestatus={changestatus}
      />
<ProductView 
  showmodal={showmodal} 
  setshowmodal={setshowmodal} 
  productdata={formdata} 
  files={files}
/>
      <ProductForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        formdata={formdata} 
        setformdata={setformdata} 
        fetchdata={fetchdata} 
      />
    </div>
  );
};

export default Product;